const Greeting = ({ name }) => {
    const getGreeting = () => {
      const hour = new Date().getHours();
      if (hour < 12) return "Good Morning";
      if (hour < 18) return "Good Afternoon";
      return "Good Evening";
    };
  
    const capitalizeFirstLetter = (str) => {
      return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
    };
  
    return (
      <div className=" pt-4 text-2xl md:text-3xl lg:text-3xl font-Montserrat font-semibold text-gray-800">
        {getGreeting()} {capitalizeFirstLetter(name)},
      </div>
    );
  };
  
  export default Greeting;
  

  